import { render } from "./UiAdd.vue?vue&type=template&id=12ba39fa&scoped=true&lang=pug"
import script from "./UiAdd.vue?vue&type=script&lang=js"
export * from "./UiAdd.vue?vue&type=script&lang=js"

import "./UiAdd.vue?vue&type=style&index=0&id=12ba39fa&lang=sass&scoped=true"

import exportComponent from "D:\\Front\\project\\valeriya.artist\\valeriya.artist.admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ba39fa"]])

export default __exports__